/**
 * `BundleLoader` — abstraction over "where do the MiniMon blobs come
 * from" so the same session code runs in Node (blobs on disk) and in
 * the browser (blobs bundled at build time via Vite raw imports).
 *
 * The types + interface live in this file so browser callers can
 * implement `BundleLoader` without pulling in `node:fs` / `node:crypto`
 * transitively. The Node default implementation lives in
 * `manifest.ts` (imported from the package's `/node` subpath only).
 */
/**
 * Convenience: `verifyIntegrity()` + throw if anything mismatches.
 * Kept out of the interface so implementations don't each need to
 * duplicate the string formatting.
 */
export async function assertBundleIntegrity(loader) {
    const report = await loader.verifyIntegrity();
    if (!report.allValid) {
        const failed = report.results
            .filter((r) => !r.match)
            .map((r) => `${r.name}: expected ${r.expectedSha256}, got ${r.actualSha256}`)
            .join('; ');
        throw new Error(`Bundled MiniMon blob integrity check failed: ${failed}`);
    }
}
//# sourceMappingURL=bundle-loader.js.map